"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.botTestRoutes = void 0;
const botTestActions_openapi_1 = require("./botTestActions.openapi");
exports.botTestRoutes = [
    {
        name: 'bot-test.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: botTestActions_openapi_1.botTestOpenApiDocs['bot-test.list']
        }
    },
    {
        name: 'bot-test.create',
        path: ['/'],
        method: 'POST',
        plugins: {
            openapi: botTestActions_openapi_1.botTestOpenApiDocs['bot-test.create']
        }
    },
    {
        name: 'bot-test.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: botTestActions_openapi_1.botTestOpenApiDocs['bot-test.get']
        }
    },
    {
        name: 'bot-test.pdf',
        path: '/pdf/:id',
        method: 'GET'
    },
    {
        name: 'bot-test.update',
        path: '/:id',
        method: 'PUT',
        plugins: {
            openapi: botTestActions_openapi_1.botTestOpenApiDocs['bot-test.update']
        }
    },
    {
        name: 'bot-test.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: botTestActions_openapi_1.botTestOpenApiDocs['bot-test.delete']
        }
    },
    {
        name: 'bot-test.run',
        path: '/run/:id',
        method: 'GET',
        plugins: {
            openapi: botTestActions_openapi_1.botTestOpenApiDocs['bot-test.run']
        }
    },
];
